<template>
  <div class="loader-div">
    <i class="fa-solid fa-spinner fa-spin-pulse"></i>
    <br />
    <br />
    <br />
    <br />
    <b>{{ LoaderText }}</b>
  </div>
</template>

<script>
export default {
  props: ["LoaderText"],
};
</script>
<style scoped>
.loader-div {
  position: relative;
  margin: 0px auto !important;
  width: 150px;
  height: 150px;
  border-radius: 15px;
  text-align: center;
  top: 5px;
  background-color: white;
}
.fa-spinner {
  position: relative;
  margin: 0px auto !important;
  top: 25%;
  font-size: 45px;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
/* This is the class name given by the Font Awesome component when icon contains 'spinner' */
.fa-spinner {
  /* Apply 'spinner' keyframes looping once every second (1s)  */
  animation: spinner 2s linear infinite;
}
</style>
